import * as React from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';

export default () => (
  <React.Fragment>
    <Container>
      You have logged out. <Link to="/">Return to Login</Link>
    </Container>
  </React.Fragment>
);
